{
  "hero.title": "Multi-CLI Environment Switcher",
  "hero.tagline-1": "enter a zen-like flow state for programming.",
  "hero.tagline-2": "seamless environment switching.",
  "hero.subtitle": "Unified management for Claude Code, Codex, and OpenCode configurations with API proxy auto-failover",
  "hero.getDocs": "Documentation",
  "features.title": "Features",
  "features.multiCli.title": "Multi-CLI Support",
  "features.multiCli.desc": "Support for Claude Code, Codex, and OpenCode with per-project configuration",
  "features.multiConfig.title": "Config Management",
  "features.multiConfig.desc": "Manage all API provider configs in a unified JSON file",
  "features.daemon.title": "Unified Daemon",
  "features.daemon.desc": "Single zend process hosts both the proxy server and the Web UI",
  "features.failover.title": "Proxy Failover",
  "features.failover.desc": "Built-in HTTP proxy with automatic failover when primary provider is unavailable",
  "features.routing.title": "Scenario Routing",
  "features.routing.desc": "Intelligent routing based on request characteristics (thinking, image, etc.)",
  "features.binding.title": "Project Bindings",
  "features.binding.desc": "Bind directories to specific profiles and CLIs for automatic project-level configuration",
  "features.envVars.title": "Environment Variables",
  "features.envVars.desc": "Configure per-CLI environment variables at the provider level",
  "features.webUi.title": "Web Interface",
  "features.webUi.desc": "Browser-based visual management with password-protected access",
  "features.webSecurity.title": "Web Security",
  "features.webSecurity.desc": "Auto-generated password, session-based auth, RSA encryption for token transport",
  "features.configSync.title": "Config Sync",
  "features.configSync.desc": "Sync providers, profiles, and settings across devices with AES-256-GCM encryption",
  "features.comingSoon": "More features coming soon, stay tuned!",
  "install.title": "Quick Start",
  "install.step1.title": "Install GoZen",
  "install.step1.desc": "One-line install script",
  "install.step2.title": "Configure Provider",
  "install.step2.desc": "Add your first API provider",
  "install.step3.title": "Launch",
  "install.step3.desc": "Start CLI with default configuration",
  "commands.title": "Commands",
  "commands.command": "Command",
  "commands.description": "Description",
  "commands.items.start": "Start CLI (uses project binding or default config)",
  "commands.items.profile": "Start with specified profile",
  "commands.items.profilePick": "Interactively select profile",
  "commands.items.cli": "Use specified CLI (claude/codex/opencode)",
  "commands.items.yes": "Auto-approve CLI permissions (claude --permission-mode acceptEdits, codex -a never)",
  "commands.items.use": "Use specified provider directly (no proxy)",
  "commands.items.pick": "Interactively select provider to start",
  "commands.items.list": "List all providers and profiles",
  "commands.items.configAddProvider": "Add a new provider",
  "commands.items.configAddProfile": "Add a new profile",
  "commands.items.configDefaultClient": "Set the default CLI client",
  "commands.items.configDefaultProfile": "Set the default profile",
  "commands.items.configResetPassword": "Reset the Web UI access password",
  "commands.items.configSync": "Pull config from remote sync backend",
  "commands.items.daemonStart": "Start the zend daemon",
  "commands.items.daemonStop": "Stop the daemon",
  "commands.items.daemonStatus": "Show daemon status",
  "commands.items.daemonEnable": "Install daemon as system service",
  "commands.items.daemonDisable": "Uninstall daemon system service",
  "commands.items.bind": "Bind current directory to profile",
  "commands.items.bindCli": "Bind current directory to specified CLI",
  "commands.items.unbind": "Unbind current directory",
  "commands.items.status": "Show current directory binding status",
  "commands.items.web": "Open Web UI in browser (auto-starts daemon)",
  "commands.items.upgrade": "Upgrade to latest version",
  "commands.items.version": "Show version",
  "commands.items.completion": "Generate shell completion (zsh/bash/fish)",
  "homepage.title": "Multi-CLI Environment Switcher"
}
